import { supabase } from '../supabaseClient';

export async function getRoster(inscripcionId) {
  const { data, error } = await supabase.rpc('get_roster_inscripcion', { p_inscripcion_id: inscripcionId });
  return { data: data || [], error };
}

export async function validarRoster(inscripcionId) {
  const { data, error } = await supabase.rpc('validar_roster_inscripcion', { p_inscripcion: inscripcionId });
  return { data: data || [], error };
}

export async function solicitarCambioRoster(inscripcionId, { tipo, jugadorId = null, nombre = null, dorsal = null, posicion = null, nota = null }) {
  const { data, error } = await supabase.rpc('solicitar_cambio_roster_item', {
    p_inscripcion: inscripcionId, p_tipo: tipo, p_jugador: jugadorId, p_nombre: nombre,
    p_dorsal: dorsal, p_posicion: posicion, p_nota: nota,
  });
  return { data, error };
}

export async function getMisCambiosRoster(inscripcionId) {
  const { data, error } = await supabase.rpc('get_mis_cambios_roster', { p_inscripcion: inscripcionId });
  return { data: data || [], error };
}

export async function getElegiblesPlayoff(inscripcionId) {
  const { data, error } = await supabase.rpc('get_elegibles_playoff', { p_inscripcion: inscripcionId });
  return { data: data || [], error };
}
